import { onSpecChange2 } from './Aux.js';

const HelpActionPomp = (props) => {

    const variaveis = ['Pax AB/para Trindade', 'Pax BA/de Trindade', 'Pax', 'Passagens ET AB', 'Passagens ET BA', 'Passagens TT AB', 'Passagens TT BA', 'Lugares AB', 'Lugares BA', 'Tx Ocupação AB', 'Tx Ocupação BA', 'Tx Ocupação Max'];

    return ( 
        <div className="helpactionpomp">
            <table className="menu" style={{borderCollapse: "collapse"}}>
                <tbody>
                    <tr className="help">
                        <td className="bgrd"></td>
                        <td className="bgrd" style={{paddingLeft: '240px'}}>
                            <a className="bgrd" href={props.helpPt}>
                                <button style={{padding: '1px 15px'}} type="button"> Ajuda </button>
                            </a>
                        </td>
                        <td className="bgrd">
                            <a className="bgrd" href={props.helpUk}>
                                <button type="button"> Help </button>
                            </a>
                        </td>
                    </tr>
                    </tbody>
            </table>
            <table>
                <tbody>
                    <tr className="action">
                        <td className="bgrd" style={{color: 'fuchsia', backgroundColor: 'rgba(205,209,220,0.2)'}}>
                            {props.ling === 'pt' && <h3 className="bgrd" style={{textAlign: "left"}}>{props.titPt} </h3>}
                            {props.ling === 'uk' && <h3 className="bgrd" style={{textAlign: "left"}}>{props.titUk} </h3>}
                        </td>
                        <td className="bgrd">
                            <label>Escolha variável </label>
                            <select name="v" id="v" 
                            onChange={(e) => props.setSpecs(onSpecChange2(e, 'nv', {...props.specs}, props.varGlob.refLim))}>
                                {variaveis.map((variavel, ind) => {
                                    return <option key={ind} >
                                        {variavel}
                                    </option>
                                })}
                            </select>
                        </td>
                        <td className="bgrd">
                            {props.ling === 'pt' && <button style={{padding: '1px 12px'}} type="button" onClick={(e) => props.query(e)}> Colorir </button>}
                            {props.ling === 'uk' && <button style={{padding: '1px 7px 1px 8px'}} type="button" onClick={(e) => props.query(e)}> To color </button>}
                        </td>
                        <td className="bgrd" >
                            <button type="button" onClick={() => props.download(props.csv, props.ling)}> CSV </button>
                        </td>
                    </tr>
                </tbody>
            </table>                     
        </div>
    );
}

export default HelpActionPomp;